module.exports = __webpack_public_path__ + "static/Hexomatic-robot-graphic-752ff3f450f720fc760f032352d5c723.jpg";